interface RosterHour {
  working?: boolean
  startTime?: number | string | null
  finishTime?: number | string | null
}

interface RosterDay {
  day?: number | string
  dayLabel?: string
  hour?: RosterHour | null
}

interface RosterWeek {
  days?: RosterDay[]
}

interface Roster {
  weeks?: RosterWeek[]
}

export function isInvalidWorkingHour(hour?: RosterHour | null): boolean {
  if (!hour?.working) return false

  if (hour.startTime == null || hour.finishTime == null) return true

  const startTime = Number(hour.startTime)
  const finishTime = Number(hour.finishTime)

  return !Number.isFinite(startTime)
    || !Number.isFinite(finishTime)
    || finishTime <= startTime
}

export function invalidWorkingRosterDays(roster?: Roster | null): string[] {
  const invalidDays = (roster?.weeks ?? []).flatMap(week =>
    (week.days ?? [])
      .filter(day => isInvalidWorkingHour(day.hour))
      .map(day => day.dayLabel || String(day.day ?? '')),
  )

  return [...new Set(invalidDays.filter(Boolean))]
}
